/* eslint-disable */
import { Injectable } from '@angular/core';
import { distinctUntilChanged, filter } from 'rxjs/operators';
import { Util } from '@libs/utilities/util';
import { AbstractExtensionPattern } from '@libs/libraries/shared';

import { NgCustomizableSliderComponent } from '../customizable-slider.component';
import { NgInputModelChange, NgModelChange } from '../shared/customizable-slider.data';


@Injectable()
export class NgSliderSubscriptionExtension extends AbstractExtensionPattern<NgCustomizableSliderComponent> {

	/**------------------------------------------------------
	 * Subscriptions
	 */
	subscribeInputModelChangeSubject() {
		this.main.inputModelChangeSubscription = this.main.inputModelChangeSubject.pipe(
				distinctUntilChanged((<any>NgModelChange.compare)),
				filter((modelChange: NgInputModelChange) => !modelChange.forceChange && !modelChange.internalChange)
			)
			.subscribe((modelChange: NgInputModelChange) => this.main.sliderValueUpdateExtension.applyInputModelChange(modelChange));
	}

	//** Subscribe output modal change subject */
	subscribeOutputModelChangeSubject() {
		this.main.outputModelChangeSubscription = this.main.outputModelChangeSubject.pipe(distinctUntilChanged(NgModelChange.compare))
			.subscribe((modelChange: any) => this.main.sliderValueUpdateExtension.publishOutputModelChange(modelChange));
	}

	//** Subscribe resize observer */
	subscribeResizeObserver() {
		if (!this.main.customizableSliderHelper.isResizeObserverAvailable()) return;
		this.main.resizeObserver = new ResizeObserver(() => this.main.sliderValueUpdateExtension.calculateViewDimensionsAndDetectChanges());
		this.main.resizeObserver.observe(this.main.elementRef.nativeElement);
	}

	//** Unsubscribe on destroy */
	unsubscribeOnDestroy() {
		this.unsubscribeResizeObserver();
		this.unsubscribeInputModelChangeSubject();
		this.unsubscribeOutputModelChangeSubject();
		this.unsubscribeManualRefresh();
		this.unsubscribeTriggerFocus();
	}

	//** Unsubscribe listener on move */
	unsubscribeOnMove() {
		if (Util.Basic.isUndefined(this.main.onMoveEventListener)) return;
		this.main.eventListenerHelper.detachEventListener(this.main.onMoveEventListener);
		this.main.onMoveEventListener = null!;
	}

	//** Unsubscribe listener on end */
	unsubscribeOnEnd() {
		if (Util.Basic.isUndefined(this.main.onEndEventListener)) return;
		this.main.eventListenerHelper.detachEventListener(this.main.onEndEventListener);
		this.main.onEndEventListener = null!;
	}

	//** Unsubscribe listener on manual refresh */
	unsubscribeManualRefresh() {
		if (Util.Basic.isUndefined(this.main.manualRefreshSubscription)) return;
		this.main.manualRefreshSubscription.unsubscribe();
		this.main.manualRefreshSubscription = null!;
	}

	//** Unsubscribe on trigger focus */
	unsubscribeTriggerFocus() {
		if (Util.Basic.isUndefined(this.main.triggerFocusSubscription)) return;
		this.main.triggerFocusSubscription.unsubscribe();
		this.main.triggerFocusSubscription = null!;
	}


	/**------------------------------------------------------
	 * Helper Function
	 */
	private unsubscribeInputModelChangeSubject() {
		if (Util.Basic.isUndefined(this.main.inputModelChangeSubscription)) return;
		this.main.inputModelChangeSubscription.unsubscribe();
		this.main.inputModelChangeSubscription = null!;
	}

	private unsubscribeOutputModelChangeSubject() {
		if (Util.Basic.isUndefined(this.main.outputModelChangeSubscription)) return;
		this.main.outputModelChangeSubscription.unsubscribe();
		this.main.outputModelChangeSubscription = null!;
	}

	private unsubscribeResizeObserver() {
		if (!this.main.customizableSliderHelper.isResizeObserverAvailable() || Util.Basic.isUndefined(this.main.resizeObserver)) return;
		this.main.resizeObserver.disconnect();
		this.main.resizeObserver = null!;
	}
}
